import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 86BB43B4-910B-4174-8455-661875054171
 * name arrow-collapse
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-collapse.svg
 * tags
 * - Arrow 
 */
export const ArrowCollapseIcon = createSvgIcon(<><path d="M19.5,3.09L15,7.59V4H13V11H20V9H16.41L20.91,4.5L19.5,3.09M4,13V15H7.59L3.09,19.5L4.5,20.91L9,16.41V20H11V13H4Z" /></>, 'ArrowCollapseIcon');
export default ArrowCollapseIcon